<template>
  <div class="column" :class="columnSize">
    <b-field
      :label="label"
      :horizontal="horizontal"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    >
      <b-select
        :value="value"
        expanded
        size="is-small"
        :disabled="disabled"
        @input="onInput"
      >
        <option value>{{ defaultOption }}</option>
        <option
          v-for="option in options"
          :value="option.value"
          :key="option.value"
        >
          {{ option.label }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String
    },
    value: {
      type: Date | String
    },
    active: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    },
    defaultOption: {
      type: String,
      default: "Please Select"
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldSelectBasic.vue